import { render, staticRenderFns } from "./ListaRequisicaoIdentificador.vue?vue&type=template&id=51802b88&"
import script from "./ListaRequisicaoIdentificador.vue?vue&type=script&lang=js&"
export * from "./ListaRequisicaoIdentificador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VEditDialog})
